import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Box, Card, ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { ArrowSolidRight } from 'seagull/icons/arrows';
import { PDF, Text } from 'seagull/icons/content-edit';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import s from './SelectCustomPageTypeModal.module.scss';
export const GetSelectCustomPageTypeModalTID = (parentTestId)=>getTestIds(parentTestId);
export const SelectCustomPageTypeModal = (param)=>{
    let { onSelect, dismissModal, allowedTypes } = param;
    const { t } = useLocaleKeys();
    const testIds = useMemo(()=>GetSelectCustomPageTypeModalTID(), []);
    const typeOptions = [
        {
            type: 'video',
            label: t.customPages.video(),
            icon: ArrowSolidRight,
            testId: testIds.SelectCustomPageTypeModalTestIds.VideoOption(),
            biName: 'select_custom_page_type_video'
        },
        {
            type: 'pdf',
            label: t.customPages.pdf(),
            icon: PDF,
            testId: testIds.SelectCustomPageTypeModalTestIds.PdfOption(),
            biName: 'select_custom_page_type_pdf'
        },
        {
            type: 'text',
            label: t.customPages.text(),
            icon: Text,
            testId: testIds.SelectCustomPageTypeModalTestIds.TextOption(),
            biName: 'select_custom_page_type_text'
        }
    ];
    const visibleTypeOptions = typeOptions.filter((param)=>{
        let { type } = param;
        return allowedTypes.includes(type);
    });
    const handleOptionClick = (type)=>{
        onSelect(type);
        dismissModal();
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'select_custom_page_type_confirm'
            },
            secondaryButton: {
                name: 'select_custom_page_type_cancel'
            }
        },
        title: t.customPages.selectType(),
        testId: testIds.SelectCustomPageTypeModalTestIds.Root(),
        onCloseButtonClick: dismissModal,
        width: "500px",
        textAlignCenter: true,
        content: /*#__PURE__*/ _jsx(Box, {
            className: s.typeOptionsRow,
            children: visibleTypeOptions.map((param)=>{
                let { type, label, icon: Icon, testId, biName } = param;
                return /*#__PURE__*/ _jsxs(Card, {
                    as: "button",
                    skin: "button",
                    highlightOnHover: true,
                    testId: testId,
                    bi: {
                        name: biName
                    },
                    className: s.typeOptionCard,
                    onClick: ()=>handleOptionClick(type),
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            size: 24
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            weight: "normal",
                            variant: "paragraph1",
                            children: label
                        })
                    ]
                }, type);
            })
        })
    });
};
export const useShowSelectCustomPageTypeModal = ()=>{
    const { showModal } = useOverlayContext();
    return useCallback((onSelect, options)=>showModal({
            biName: 'select_custom_page_type_modal',
            openBottomSheetOnMobile: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(SelectCustomPageTypeModal, {
                    onSelect: onSelect,
                    dismissModal: dismissModal,
                    allowedTypes: options.allowedTypes
                });
            }
        }), [
        showModal
    ]);
};
